import React, { FunctionComponent } from 'react';
import { IImage } from '../../../../../../common/model/ICarDetails';
import sliderImageStyles from './SliderImageStyles';
import { Box } from '@material-ui/core';
import Image from 'material-ui-image';

interface ISliderImage {
  image?: IImage;
  index?: number;
  defaultSrc?: string;
  alt?: string;
}

const SliderImage: FunctionComponent<ISliderImage> = ({ image, index, defaultSrc, alt }) => {
  const styles = sliderImageStyles();

  return (
    <Box className={styles.container} width="80%">
      <Image
        src={image?.url || defaultSrc}
        color="transparent"
        animationDuration={0}
        imageStyle={{ height: '100%', width: '100%', maxHeight: '320px', objectFit: 'contain' }}
        aspectRatio={2.3}
        data-test={`image:variant:${image ? index : 'unavailable'}`}
        alt={`${alt} ${image?.type}`}
      />
    </Box>
  );
};

export default SliderImage;
